export default __webpack_public_path__ + "assets/ico_block_aprove-d2f2e6b6.svg";